// Модалът „Плащане" за избраните доставки: дата (не по-късна от днес), начин
// (В брой / Банков превод / Карта) и основание — референцията СЕ ЗАПИСВА.
// `initial` (при „Промени" на платена) — досегашното плащане; без него —
// днес, Банков превод, празно основание. antd Modal: Esc отказва,
// Ctrl/Cmd+Enter потвърждава.
import { useEffect, useState } from "react";
import { Modal } from "antd";
import type { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";
import type { DeliveryPaymentMethod } from "../../../../api/inventory";
import { modalStyles } from "../../../../utils/modalStyles";
import { PRIMARY_BUTTON_CLASS, SECONDARY_BUTTON_CLASS } from "../../components/list/buttonStyles";
import { PaymentFields } from "./PaymentFields";
import { defaultPaymentFields, type PaymentFieldsValue } from "./paymentFieldsModel";

type Props = {
  open: boolean;
  subtitle: string;
  saving: boolean;
  initial?: PaymentFieldsValue;
  onCancel: () => void;
  onConfirm: (payment: { paidAt: Dayjs; method: DeliveryPaymentMethod; reference: string | null }) => void;
};

export const PayDeliveriesModal = ({ open, subtitle, saving, initial, onCancel, onConfirm }: Props) => {
  const { t } = useTranslation();
  const [value, setValue] = useState<PaymentFieldsValue>(() => initial ?? defaultPaymentFields());
  // всяко отваряне тръгва от началните стойности (или от днес)
  useEffect(() => {
    if (open) setValue(initial ?? defaultPaymentFields());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  const confirm = () =>
    onConfirm({ paidAt: value.paidAt, method: value.method, reference: value.reference.trim() || null });
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      closable={false}
      destroyOnHidden
      width={440}
      styles={modalStyles}
      style={{ maxWidth: "calc(100vw - 20px)" }}
    >
      <div
        className="flex flex-col bg-surface"
        onKeyDown={(event) => {
          if ((event.ctrlKey || event.metaKey) && event.key === "Enter") {
            event.preventDefault();
            confirm();
          }
        }}
      >
        <div className="flex flex-col gap-[3px] border-b border-shade-2 px-[22px] py-[18px]">
          <span className="text-[17px] font-semibold text-ink">{t("inventoryPage.payModalTitle")}</span>
          <span className="text-[13px] text-body">{subtitle}</span>
        </div>
        <div className="flex flex-col gap-3.5 px-[22px] py-4">
          <PaymentFields value={value} onChange={setValue} autoFocus />
        </div>
        <div className="flex items-center justify-end gap-2 border-t border-shade-2 px-[22px] pb-[18px] pt-3.5">
          <button type="button" onClick={onCancel} className={SECONDARY_BUTTON_CLASS}>
            {t("inventoryPage.cancel")}
          </button>
          <button type="button" disabled={saving} onClick={confirm} className={PRIMARY_BUTTON_CLASS}>
            {t("inventoryPage.payConfirm")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PayDeliveriesModal;
